<template>
  <div class=""></div>
</template>

<script>
export default {
  name: "",
  mixins: [],
  components: {},
  props: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  created() {
    let game_id = this.$route.query.game_id;
    let token = this.$route.query.token;
    console.log(game_id, token);
    if (game_id && token) {
      this.autoLogin(game_id, token);
    }
  },
  mounted() {},
  methods: {
    async autoLogin(game_id, token) {
      let webUUID = await Adjust.getWebUUID();
      let params = {
        game_id,
        token,
        device_id: webUUID,
      };
      this.$http.post("/apis/h5/normalReg", params).then((res) => {
        if (res.code === 200) {
          switch (Number(params.game_id)) {
            case 14:
              Adjust.trackEvent({
                eventToken: "1pfywu",
              });
              Adjust.trackEvent({
                eventToken: "ilhflt",
              });
              break;
            case 15:
              Adjust.trackEvent({
                eventToken: "2bv3cx",
              });
              Adjust.trackEvent({
                eventToken: "5taqik",
              });
              break;
            default:
              break;
          }
          localStorage.setItem("token", res.data.token);
          localStorage.setItem("userid", res.data.userid);
          localStorage.setItem("iframeURL", res.data.login_url);
          localStorage.removeItem("guestInfo");
          this.$store.state.token = res.data.token;
          this.$store.state.iframeURL = res.data.login_url;
          // this.$router.push("/main");
          this.$router.push("/main/my");
          this.$store.state.sdkShow = false;
          this.$store.commit("openSdk", false);
        } else {
          this.$Msg(res.msg);
        }
      });
    },
  },
};
</script>

<style scoped lang="scss"></style>
